export const doUpdateSite = async (objectid, siteData) => {
  try {
    const response = await fetch(`/sites/${objectid}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(siteData),
    });
    const data = await response.json();
    return response.ok ? { success: true, site: data } : { success: false, ...data };
  } catch (error) {
    return { success: false, function: "doUpdateSite", stack: error.message };
  }
};